export const CREATE_DRAFT = 'storeBonusCreatePage/CREATE_DRAFT';

export const FETCH_ITEM = 'storeBonusCreatePage/FETCH_ITEM';

export const GO_TO_STEP_ONE = 'storeBonusCreatePage/GO_TO_STEP_ONE';

export const GO_TO_STEP_TWO = 'storeBonusCreatePage/GO_TO_STEP_TWO';

export const SUBMIT = 'storeBonusCreatePage/SUBMIT';
